module.exports = __webpack_public_path__ + "img/horizontal_6_7_3016.6b3784c6.png";